<template>
  <div>
    <pre>{{ transaction.response_data }}</pre>
    <!-- <div
      class="ui form"
      v-if="
        transaction.response_data.result &&
          transaction.response_data.result.response
      "
    >
      <div class="ui dividing small header">{{ $t("sale") }}</div>
      <div class="five fields">
        <div class="field">
          <label for="">{{ $t("audit number") }}</label>
          <input
            type="text"
            v-model="transaction.response_data.result.response.auditNumber"
          />
        </div>
        <div class="field">
          <label for="">{{ $t("reference number") }}</label>
          <input
            type="text"
            v-model="transaction.response_data.result.response.referenceNumber"
          />
        </div>
        <div class="field">
          <label for="">{{ $t("authorization number") }}</label>
          <input
            type="text"
            v-model="
              transaction.response_data.result.response.authorizationNumber
            "
          />
        </div>
        <div class="field">
          <label for="">{{ $t("response code") }}</label>
          <input
            type="text"
            v-model="transaction.response_data.result.response.responseCode"
          />
          <div class="field"></div>
        </div>
        <div class="field">
          <label for="">{{ $t("message type") }}</label>
          <input
            type="text"
            v-model="transaction.response_data.result.response.messageType"
          />
          <div class="field"></div>
        </div>
      </div>
    </div>
    <div class="ui negative message" v-if="transaction.response_data.err">
      <div class="header">
        {{ $t("error") }}
      </div>
      <pre>{{ transaction.response_data }}</pre>
    </div> -->
  </div>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import { translate_status, translate_type } from "../local_translator";

filters.translate_status = translate_status;
filters.translate_type = translate_type;

export default {
  name: "FelGTTransactionModalResponse",
  filters: filters,
  components: {},
  props: { transaction: Object },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
